import React from 'react'
import { Icon, Text, Flex, Link } from '@afterpaytouch/core'
import { Trans } from '../../../utils/convergence'
import { useTranslation } from '../../../utils/convergence'
import { useAppRouter } from '../../../state'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../utils/responsive'

export const AddPaymentMethod = (): JSX.Element => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const { textSize, smallTextSize } = useCheckoutSizes()

  const handleAddPaymentMethod = (): void => {
    router.push(Route.NEW_PAYMENT_METHOD)
  }

  const components = {
    navLink: (
      <Link kind='Underline' onClick={handleAddPaymentMethod}>
        {t('summary:addPaymentMethod')}
      </Link>
    ),
  }

  return (
    <Flex alignItems='flex-start' className={styles.container}>
      {/* // TODO: Update icon */}
      <Icon.Card size='Medium' color='Black' />
      <Flex direction='column' className={styles.textContainer}>
        <Text size={textSize} bold>
          {t('summary:paymentMethodTitle')}
        </Text>
        <Text size={smallTextSize}>
          <Trans i18nKey='summary:addPaymentMethodWithDebitCard' components={components} />
        </Text>
      </Flex>
    </Flex>
  )
}
